<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="contrast w1200">
			<div class="flex famous_position">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/career" class="cl_gray">生涯规划</router-link>
					  >  <router-link to="/choice" class="cl_gray">3+2+1选科</router-link>  >  选科查询系统</p>
				</div>
			</div>
			<div class="choice">
				<div class="choice_nav">
					<router-link to="/choice_subject" class="choice_nav_list f18px cl_dark">按科目组合查专业</router-link>
					<router-link to="/choice_intention" class="choice_nav_list f18px cl_dark">按意向志愿选科目</router-link>
					<router-link to="/choice_major" class="choice_nav_list f18px cl_dark on">按专业名称查科目</router-link>
					<router-link to="/choice_collect" class="choice_nav_collect f18px cl_violet">我的收藏</router-link>
				</div>
				<div class="choice_major_select_top">
					<div class="famous_screen_list">
						<span class="cl_gray f18px">院校层次：</span>
						<el-select v-model="ccValue" clearable placeholder="请选择" @change="ccSelect">
							<el-option v-for="item in cc":key="item" :label="item":value="item"></el-option>
						</el-select>
					</div>
					<div class="famous_screen_list">
						<span class="cl_gray f18px">专业名称：</span>
						<input type="text" v-model="majorNmae" placeholder="输入专业" class="f16px cl_gray choice_major_name" />
						<button type="button" class="cl_white f16px choice_major_submit" @click="query">查询</button>
					</div>
				</div>
				<div class="choice_select">
					<div class="famous_screen_list">
						<span class="cl_gray f18px">个人偏好：</span>
						<el-select v-model="sdValue" clearable placeholder="按院校所在地筛选" @change="sdSelect">
							<el-option v-for="item in sd":key="item.id" :label="item.name":value="item.id"></el-option>
						</el-select>
					</div>
					<div class="famous_screen_list">
						<el-select v-model="typeValue" clearable placeholder="按院校类型" @change="typeSelect">
							<el-option v-for="item in type":key="item" :label="item":value="item"></el-option>
						</el-select>
					</div>
					<div class="famous_screen_list major_screen_list">
						<p class="choice_major_zh f16px cl_gray" @click="addComb">按科目组合筛选</p>
						<div class="bg" v-if="combShow" @click="cancel"></div>
						<div class="choice_major_hide bg_white radius8"  v-if="combShow">
							<div class="choice_major_hide_cont">
								<div class="famous_screen_list">
									<span class="cl_gray f18px">首选1门科目：</span>
									<el-select v-model="firstValue" placeholder="请选择" @change="firstSelect" class="mat5">
										<el-option v-for="item in first":key="item.subjectId" :label="item.subjectName":value="item.subjectId"></el-option>
									</el-select>
								</div>
								<div class="famous_screen_list mat20">
									<span class="cl_gray f18px">再选2门科目：</span>
									<el-select v-model="secondValue" multiple :multiple-limit="2" placeholder="请选择" @change="secondSelect" class="mat5">
										<el-option v-for="item in second":key="item.subjectId" :label="item.subjectName":value="item.subjectId"></el-option>
									</el-select>
								</div>
							</div>
							<div class="comb_btm mat20">
								<button type="button" class="f18px cl_white comb_confirm" @click="setUp">确定</button>
							</div>
						</div>
					</div>
				</div>
				<div class="choice_select_comb flex" v-if="combDefault.name">
					<div class="choice_select_comb_l">
						<span class="f18px cl_red mar15">组合：{{combDefault.name}}</span>
						<i class="f16px cl_dark">可报考专业如下</i>
					</div>
					<button type="button" v-if="combDefault.is_fav == 0" class="choice_collect cl_violet" @click="collect">收藏组合</button>
					<button type="button" v-else class="choice_collect_already cl_white" @click="collect">已收藏组合</button>
				</div>
				<div class="choice_table_cont mat20" v-if="list.length > 0">
					<table class="choice_table">
						<thead>
							<tr class="f18px">
								<th width="300px">院校名称</th>
								<th width="300px">专业名称</th>
								<th width="200px">本专科批次</th>
								<th width="200px">首选科目</th>
								<th width="200px">再选科目</th>
							</tr>
						</thead>
						<tbody class="f16px cl_dark">
							<tr v-for="(item,index) in list" :key="index">
								<td>
									<router-link :to="{ path: '/treasury_details', query: { id: item.university_id, type: 4}}" class="f18px cl_black">{{item.university_name}}</router-link>
									<div class="choice_table_tip f12px tc mat20">
										<div class="choice_table_item cl_white" v-for="(item,index) in item.featureList" :key="index" :class="[{'first': item == '985工程'},{'second': item == '211工程'}]">{{item}}</div>
										<div class="choice_table_item choice_table_item_last cl_violet" v-if="item.city_name != null">{{item.city_name}}</div>
									</div>
								</td>
								<td><p>{{item.major_name}}</p></td>
								<td align="center"><p>{{item.level}}</p></td>
								<td align="center">
									<p v-if="item.subject_one_name_data.length == 0">不限</p>
									<p v-else>{{item.subject_one_name_data[0]}}(必选)</p>
								</td>
								<td align="center">
									<p v-if="item.subject_two_name_data.length == 0">不限</p>
									<p v-else><span v-for="(item,index) in item.subject_two_name_data" :key="index">{{item}} </span>({{item.subject_two_name_data.length}}选1)</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray">共 {{total}} 条记录 页次：{{currentPage}}/{{Math.ceil(total/pageSize)}}页   {{pageSize}}条/页</div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next, jumper" @size-change="handleSizeChange" 
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<p>数据为空，请重新选择组合</p>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'choice_major',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 1,
				comb: [], //组合列表
				combDefault : {}, //选中组合
				combShow: false, //添加显示
				majorNmae: "", //专业名称
				firstValue: "", //首选
				first: [],
				secondValue: "", //次选
				second: [],
				ccValue: "", //院校层次
				cc: [],
				sdValue: "", //院校属地
				sd: [],
				typeValue: "", //院校类型
				type: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总条数
				list: [], //院校列表
			}
		},
		mounted() {
			this.getComb();
			this.getUni();
			this.getSd();
			this.getType();
			this.getFirst();
			this.getSecond();
			this.getList();
		},
		created() {
			
		},
		methods: {
			//查询
			query () {
				this.getList();
			},
			//获取组合
			getComb () {
				var that = this;
				that.$get("/api/selectsubject/get_select_subject_data",{token: localStorage.getItem("token")})
				.then(res => {
					that.comb = res.data;
				});
				
			},
			//院校层次
			getUni () {
				var that = this;
				that.$get("/api/careerbible/get_level_data",{})
				.then(res => {
					that.cc = res.data;
					//that.ccValue = that.cc[0];
				});
			},
			//院校属地
			getSd () {
				var that = this;
				that.$get("/api/careerbible/get_province_data",{})
				.then(res => {
					that.sd = res.data;
					// that.sdValue = that.sd[0].id;
				});
			},
			//院校类型
			getType () {
				var that = this;
				that.$get("/api/careerbible/get_type_data",{})
				.then(res => {
					that.type = res.data;
					// that.typeValue = that.type[0];
				});
			},
			//首选
			getFirst () {
				var that = this;
				that.$get("/api/selectsubject/get_one_subject_data",{})
				.then(res => {
					that.first = res.data;
				});
			},
			//次选
			getSecond () {
				var that = this;
				that.$get("/api/selectsubject/get_two_subject_data",{})
				.then(res => {
					that.second = res.data;
				});
			},
			//创建,取消
			setUp () {
				var that = this;
				if (that.secondValue.length != 2 || that.firstValue.length == "") {
					that.$message({
						duration: 1500,
						message: "请选择完整科目",
						type: 'warning'
					});
					return false
				}
				let subject_one_id_str = that.firstValue;
				let subject_two_id_str = that.secondValue.join(",");
				for (let i = 0; i < that.comb.length; i++) {
					if (subject_one_id_str == that.comb[i].subject_1_id_str && subject_two_id_str.split(",").toString() == that.comb[i].subject_2_id_str.split(",").toString()) {
						that.combShow = false;
						that.combDefault = that.comb[i];
						that.firstValue = "";
						that.secondValue = "";
						that.getList();
						return false
					}
				}
				that.$get("/api/selectsubject/post_select_subject",{
					subject_one_id_str: subject_one_id_str,
					subject_two_id_str: subject_two_id_str,
					token: localStorage.getItem("token"),
				})
				.then(res => {
					that.combShow = false;
					that.combDefault = res.data;
					that.firstValue = "";
					that.secondValue = "";
					that.getList();
				});
			},
			cancel () {
				this.combShow = false;
			},
			addComb () {
				this.combShow = true;
			},
			//收藏组合
			collect () {
				var that = this;
				that.$get("/api/selectsubject/post_collect_select_subject",{
					token: localStorage.getItem("token"),
					id: that.combDefault.id,
				})
				.then(res => {
					that.$message({
						duration: 1500,
						message: res.msg,
						type: 'success'
					});
				});
			},
			//获取学校
			getList () {
				var that = this;
				that.$get("/api/selectsubject/get_name_major_data",{
					token: localStorage.getItem("token"),
					page: that.currentPage,
					limit: that.pageSize,
					province_id: that.sdValue,
					type: that.typeValue,
					level: that.ccValue,
					name: that.majorNmae,
					subject_one_id_str: that.combDefault.subject_1_id_str,
					subject_two_id_str: that.combDefault.subject_2_id_str,
				})
				.then(res => {
					that.list = [];
					that.list = res.data.data;
					that.total = res.data.total;
					for (let i = 0; i < that.list.length; i++) {
						that.list[i].featureList = [];
						if (that.list[i].feature != '' && that.list[i].feature != null) {
							that.list[i].featureList = that.list[i].feature.split(",");
						}
					}
				});
			},
			//下拉选择
			firstSelect (e) {
				
			},
			secondSelect (e) {
				
			},
			ccSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			sdSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			typeSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			handleSizeChange: function (size) {
							this.pageSize = size;
							console.log(this.pageSize)  //每页下拉显示数据
			},
			handleCurrentChange: function(currentPage){
							this.currentPage = currentPage;
							this.getList();
							console.log(this.currentPage)  //点击第几页
			},
		},
	}
</script>

<style>
</style>
